import { OperationalStatus, StoreSchedule, WeeklyOpeningHours } from '@shared/models';
import { ElasticSearchResponse, StoreDocument } from '@shared/services/elastic-search/models';

export const storesScheduleSerializer = (response: ElasticSearchResponse<StoreDocument>): StoreSchedule => {
  const store = response.hits.hits[0]!._source;
  const weeklyOpeningHours = store.weekly_opening_hours?.[0];
  const exceptionalClosures = store.exceptional_closures?.[0];
  const exceptionalOpenings = store.exceptional_openings?.[0];
  const operationalStatus = store.operational_status?.[0];
  return {
    weeklyOpeningHours: weeklyOpeningHours ? (JSON.parse(weeklyOpeningHours) as WeeklyOpeningHours) : null!,
    exceptionalClosures,
    exceptionalOpenings,
    operationalStatus: operationalStatus ? (JSON.parse(operationalStatus) as OperationalStatus) : null!,
  };
};
